import React from "react";
import { Content, Icon, DropZoneText, ImageWrapper, Image } from "./styles";
import { LineBreak, Row } from "components/shared/layout";
import Button from "components/button";

const Success = ({ onReUpload, onDone, file = null }) => {
  console.log('@@@ file: ', file);

  return (
    <Content uploaded={true} image={!!file}>
      {/* {!file ? (
        <>
          <Icon
            src={require("assets/images/upload-tick-icon.svg")}
            alt="Drop file here"
          />
          <DropZoneText uploaded={true}>
            File successfully uploaded
          </DropZoneText>
        </>
      ) : (
        <ImageWrapper>
          <Image src={file.fileURL} />
        </ImageWrapper>
      )} */}
      {!!file && file.fileURL}
      <DropZoneText uploaded={true}>
        File successfully uploaded
      </DropZoneText>

      <Row justifyContent="center">
        <Button
          onClick={onReUpload}
          style={{ minWidth: 150, margin: "5px" }}
          variant="zltoDarkBlue"
        >
          Re-upload
        </Button>
        <Button
          onClick={onDone}
          style={{ minWidth: 150, margin: "5px" }}
          variant="zltoLightBlue"
        >
          Done
        </Button>
      </Row>
    </Content>
  );
};

const Default = ({ isDragActive, mobile, acceptImage = false, name }) => {
  const text = !!name
  ? name
  : !!acceptImage
    ? "image"
    : "file";

  return (
    <Content uploaded={false}>
      <Icon
        src={require("assets/images/attachment-icon.svg")}
        alt="Drop file here"
      />
      {isDragActive ? (
        <DropZoneText>
          Drop the {text}(s) <span>here</span>
        </DropZoneText>
      ) : mobile ? (
        <DropZoneText>
          Upload your <br /> {text} <span>here</span>
        </DropZoneText>
      ) : (
        <DropZoneText>
          Drag and drop or <LineBreak minW="500px" /> upload your {text}{" "}
          <span>here</span>
        </DropZoneText>
      )}
    </Content>
  );
};

export { Success, Default };
